<template>
  <el-dialog :title="getTitle"
             :visible.sync="showType"
             :close-on-click-modal="false"
             @close="handleCancel"
             width="40%">
    <el-col :span="24">
      <el-form :model="menuForm"
               :rules="rules"
               ref="menuForm"
               label-width="100px"
               class="reset-form">
        <el-form-item label="父级"
                      prop="parent_id">
          <el-select v-model="menuForm.parent_id">
            <el-option label="无"
                       value="0"></el-option>
            <el-option v-for="(item, index) in moduleList"
                       :key="index"
                       :label="item.name"
                       :value="item.id"
                       placeholder="请选择父级模块"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题:"
                      prop="name">
          <el-input v-model.trim="menuForm.name"
                    placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="code:"
                      prop="code">
          <el-input v-model.trim="menuForm.code"
                    placeholder="请输入code"></el-input>
        </el-form-item>
        <el-form-item label="菜单类型"
                      prop="perm_type">
          <el-select v-model="menuForm.perm_type">
            <el-option v-for="(item, index) in menuType"
                       :key="index"
                       :label="item.name"
                       :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="菜单uri:"
                      prop="uri"
                      :rules="[
            { required: this.menuForm.perm_type !== 'perm_type_menu0', message: '请输入菜单uri' }
          ]">
          <el-input v-model.trim="menuForm.uri"
                    placeholder="请输入菜单uri"></el-input>
        </el-form-item>
        <el-form-item label="菜单图标:"
                      prop="icon">
          <el-input v-model.trim="menuForm.icon"
                    placeholder="请输入菜单图标"></el-input>
        </el-form-item>
        <el-form-item label="排序:"
                      prop="sort">
          <el-input v-model.trim="menuForm.sort"
                    placeholder="请输入排序"></el-input>
        </el-form-item>
      </el-form>
    </el-col>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button v-has="'/permission/add' || '/permission/edit'"
                 type="primary"
                 @click="handleSave('menuForm')">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import fetch from '@/common/api'
export default {
  props: {
    isShow: {
      type: Boolean
    },
    data: {
      type: Object
    }
  },
  data() {
    return {
      showType: this.isShow,
      typeName: '添加功能',
      menuForm: {
        parent_id: '',
        name: '',
        uri: '',
        code: '',
        perm_type: 'perm_type_menu0',
        icon: '',
        sort: '',
        creator: localStorage.getItem('uId')
      },
      rules: {
        parent_id: [{ required: true, message: '请选择父级模块名称' }],
        name: [{ required: true, message: '请选择详细模块' }],
        perm_type: [{ required: true, message: '请选择菜单级别' }],
        sort: [{ required: true, message: '请输入排序序号' }]
      },
      moduleList: [],
      menuType: [],
      tmpArr: []
    }
  },
  computed: {
    getTitle() {
      return this.data.type === 'add' ? '添加菜单' : '编辑菜单'
    }
  },
  created() {
    this.getAuthorityList()
    this.getItemList()
    if (this.data.type === 'edit') {
      this.getInfo()
    }
    if (this.data.type === 'add' && this.data.id) {
      this.menuForm.parent_id = this.data.id
    }
  },
  methods: {
    // 获取全部模块
    getAuthorityList() {
      fetch.getMenuList({}).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.moduleList = this.titleFormat(data.list, '• ')
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 获取菜单类型
    getItemList() {
      fetch.getItemList({ type_code: 'perm_type' }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.menuType = data.list
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 获取编辑信息
    getInfo() {
      fetch.getMenuInfo({ id: this.data.id }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.menuForm = data
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    handleSave(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.data.type === 'add') {
            fetch.addMenu({ ...this.menuForm }).then((data) => {
              data.procData(
                data.res,
                () => {
                  this.$message.success('操作成功')
                  this.handleCancel('refresh')
                  this.$store.commit('freshMenu', { flag: true })
                },
                (err) => {
                  this.$message.error(err)
                }
              )
            })
          } else {
            fetch.editMenu({ ...this.menuForm }).then((data) => {
              data.procData(
                data.res,
                () => {
                  this.$message.success('操作成功')
                  this.handleCancel('refresh')
                  this.$store.commit('freshMenu', { flag: true })
                },
                (err) => {
                  this.$message.error(err)
                }
              )
            })
          }
        } else {
          return false
        }
      })
    },
    handleCancel(type) {
      this.$emit('handleClose', type)
    },
    //  格式化名称
    titleFormat(data, prefix) {
      if (data.length === 0) {
        return []
      }
      data.forEach((item) => {
        let tmp = item
        tmp.name = prefix + item.name
        this.tmpArr.push(tmp)
        if (item.findList && item.findList.length > 0) {
          this.titleFormat(item.findList, '• ' + prefix)
        }
      })
      return this.tmpArr
    }
  }
}
</script>

<style lang="less" scoped></style>
